// dependencies
import { isImmutable } from "immutable";

// actions
import { DisplayError } from "../../actions/notifications.actions";

import get from "../../utils/GetNested";

// utils
import ErrorParser from "./parser";

const ErrorMiddleware = (store) => (next) => (action) => {
	/*
        Looks for failed request actions. Will put up an
        error card if one is passed through.
    */

	const { dispatch } = store;
	const { type, response, data } = action;

	const ignoreFailed = get(action, ["request", "props", "params", "ignoreFailed"], false);

	/**
	 * TODO: remove try...catch
	 *
	 * Currently the errors are coming in two different formats. This is not a
	 * server issue, its an issue with some things using redux-process and
	 * other requests using the old style. Once redux-process allows for a
	 * configurable default error hook, I will update this.
	 */
	if (type.indexOf("@FAIL") >= 0 && ignoreFailed !== true) {
		let errors = [];

		try {
			let actionData = response.data;

			let errorVersion = 0;

			if (
				isImmutable(response) &&
				response.has("errors") &&
				response.getIn(["errors", 0, "code"], null) !== null
			) {
				errorVersion = 3;
				actionData = response.get("errors");
			} else if (isImmutable(response) && response.has("errors")) {
				actionData = response.get("errors").toJS();
			}

			errors = ErrorParser(actionData, errorVersion);
		} catch (err) {
			try {
				errors = ErrorParser(data.errors);
			} catch (errr) {
				errors = [];
			}
		}

		errors.forEach((error) => {
			dispatch(DisplayError(error.errorMessage));
		});
	}

	next(action);
};

export default ErrorMiddleware;
